import axios from "axios";

interface OliverInitializeData {
  availabilityID: string | undefined;
  requestID: string | undefined;
  timezone: string | undefined;
}

interface UserResponse {
  userResponse: string | undefined;
  availabilityID: string | undefined;
  requestID: string | undefined;
  timezone: string | undefined;
}

export const initializeOliverChat = async (
  data: OliverInitializeData,
  oliverUrl: string
) => {
  try {
    if (data.availabilityID && data.requestID && data.timezone) {
      const response = await axios.post(oliverUrl, data);
      if (response.data.messages.length > 0) {
        return response.data.messages;
      }
    }
    return [];
  } catch (error) {
    console.error(`error: ${error}`);
  }
};

export const usersResponse = async (data: UserResponse, oliverUrl: string) => {
  const reconstructedData = {
    messages: [{ role: "user", content: data.userResponse }],
    availabilityID: data?.availabilityID,
    requestID: "sqdsjlk",
    timezone: data?.timezone
  };

  const response = await axios.post(
    `${oliverUrl}generate_content`,
    reconstructedData
  );

  return {
    messages: response.data.messages[0],
    availableSlots: response.data.availableSlots
  };
};
